// import { Typography } from "@mui/material";
// import { useSelector } from "react-redux";
// import { storage } from '../firebaseConfig';  // Import Firebase storage
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; // Import Firebase Storage functions

// export default function Game() {
//     const users = useSelector((state) => state.users.users);

//     // Function to upload image and get the download URL
//     const uploadImageToFirebase = async (imageFile) => {
//       try {
//         // Create a reference for the file in Firebase Storage
//         const storageRef = ref(storage, `0000logo/${imageFile.name}`);

//         // Upload the file to the specified reference
//         const uploadTaskSnapshot = await uploadBytes(storageRef, imageFile);

//         // Get the download URL after the upload is complete
//         const downloadURL = await getDownloadURL(uploadTaskSnapshot.ref);

//         console.log('Image uploaded successfully, download URL:', downloadURL);
//         return downloadURL;
//       } catch (error) {
//         console.error('Error uploading image:', error);
//         throw error;
//       }
//     };

//     const handleImageUpload = async (imageFile) => {
//       try {
//         const imageUrl = await uploadImageToFirebase(imageFile);
//         console.log('Image URL:', imageUrl);
//         // Save imageUrl to MongoDB or use it in your app
//       } catch (error) {
//         console.error('Failed to upload image:', error);
//       }
//     };

//     // Example: Call this function when user selects an image
//     const onSelectImage = (event) => {
//       const imageFile = event.target.files[0];  // Get the image file from file input
//       if (imageFile) {
//         handleImageUpload(imageFile);
//       }
//     };

//     return (
//         <div style={{ 
//             display: "flex", 
//             width: "95%", 
//             margin: "0 auto", 
//             flexDirection: "row", 
//             gap: "30px", 
//             flexWrap: "wrap" 
//         }}>
//             <input type="file" onChange={onSelectImage} /> {/* Input to select and upload image */}

//             {users?.filter(user => user.logoUrl).map(user => (
//                 <UserWidget key={user.id} user={user} />
//             ))}
//         </div>
//     );
// }

// function UserWidget({ user }) {
//     return (
//         <div style={{ 
//             flexBasis: "45%", 
//             border: "1px solid #ccc", 
//             padding: "10px", 
//             borderRadius: "8px", 
//             display: "flex", 
//             alignItems: "center", 
//             gap: "15px" 
//         }}>
//             <img
//                 src={user.logoUrl}
//                 alt={`${user.name}'s logo`}
//                 style={{
//                     width: `100px`,
//                     height: `100px`,
//                     objectFit: "fit",
//                     borderRadius: "4px",
//                     border: "2px solid green"
//                 }}
//             />
//             <div>
//                 <Typography variant="h6" style={{ fontWeight: "bold" }}>{user.name}</Typography>
//                 <Typography variant="body1">Mogadishu - Somalia</Typography>
//             </div>
//         </div>
//     );
// }


import React, { useState } from "react";
import Tesseract from "tesseract.js";

export default function InvoiceUploader() {
  const [image, setImage] = useState(null);
  const [numbers, setNumbers] = useState([]);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  const processImage = async () => {
    if (!image) return;
    setLoading(true);

    try {
      const { data } = await Tesseract.recognize(image, "eng");
      const text = data.text;

      // Extract numbers using regex
      const extractedNumbers = text.match(/\d+(\.\d+)?/g) || [];
      const numericValues = extractedNumbers.map(Number);

      // Calculate total
      const sum = numericValues.reduce((a, b) => a + b, 0);

      setNumbers(numericValues);
      setTotal(sum);
    } catch (err) {
      console.error(err);
      alert("Error processing image");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "15px" }}>
        Upload Invoice
      </h2>

      <input type="file" accept="image/*" onChange={handleFileChange} />

      {image && (
        <div style={{ marginTop: "20px" }}>
          <img
            src={image}
            alt="invoice preview"
            style={{
              maxWidth: "300px",
              border: "1px solid #ccc",
              padding: "10px",
              display: "block",
              marginBottom: "10px",
            }}
          />

          <button
            onClick={processImage}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {loading ? "Processing..." : "Extract & Calculate"}
          </button>
        </div>
      )}

      {numbers.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ fontWeight: "600" }}>Numbers Found:</h3>
          <p>{numbers.join(", ")}</p>
          <h3 style={{ fontWeight: "bold", marginTop: "10px" }}>
            Total: {total}
          </h3>
        </div>
      )}
    </div>
  );
}
